import { getAuth } from "firebase/auth";

let cachedToken = null;
let tokenExpiry = null;

export async function getAuthToken() {
  const auth = getAuth();

  // if we have a valid cached token, return it immediately
  if (cachedToken && tokenExpiry && Date.now() < tokenExpiry) {
    return cachedToken;
  }

  // wait for auth to be ready only if no current user
  if (!auth.currentUser) {
    await new Promise((resolve) => {
      const unsubscribe = auth.onAuthStateChanged((user) => {
        unsubscribe();
        resolve();
      });
    });
  }

  const user = auth.currentUser;
  if (!user) return null;

  try {
    const token = await user.getIdToken(false); // false = don't force refresh
    // cache token for 55 minutes (tokens expire after 60)
    cachedToken = token;
    tokenExpiry = Date.now() + 55 * 60 * 1000;
    return token;
  } catch (err) {
    console.error("getAuthToken error:", err);
    cachedToken = null;
    tokenExpiry = null;
    return null;
  }
}

// call this on logout to clear the cache
export function clearAuthTokenCache() {
  cachedToken = null;
  tokenExpiry = null;
}
